import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the TableReferralsAwardsReportView.
 * @extends JetView
 */
export default class TableReferralsAwardsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        // DataTable configuration for displaying referral awards report
        const detailReport = {
            view: 'datatable', // DataTable view
            id: 'datatableDetails', // Unique ID for the DataTable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            columns: [
                // Column definitions for the DataTable
                {
                    id: 'ReferentId',
                    header: _('ID Referente'), // Header text for the column
                    width: 100,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ReferredId',
                    header: _('ID Referido'),
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'AwardId',
                    header: _('Premio ID'),
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'ChoicedBonus',
                    header: _('Bono elegido'),
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'ConditionType',
                    header: _('Condición'),
                    width: 250,
                    sort: 'text',
                    /**
                     * Template function to display condition type based on its value.
                     * @param {Object} obj - The data object for the row.
                     * @returns {String|null} The condition type as a string or null.
                     */
                    template: function (obj) {
                        return obj.ConditionType == '1'
                            ? '“Mínimo primer depósito'
                            : obj.ConditionType == '2'
                              ? 'Mínimo valor en apuestas'
                              : obj.ConditionType == '3'
                                ? 'Cuenta verificada'
                                : null;
                    },
                },
                {
                    id: 'TargetValue',
                    header: _('Valor objetivo'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'CurrentValue',
                    header: _('Valor actual'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'State',
                    header: _('Estado'),
                    width: 150,
                    sort: 'text',
                    /**
                     * Template function to display state based on its value.
                     * @param {Object} obj - The data object for the row.
                     * @returns {String|null} The state as a string or null.
                     */
                    template: function (obj) {
                        const stateMap = {
                            1: 'Pendiente',
                            2: 'Cumplido',
                            3: 'Redimido',
                            4: 'Fallido',
                            5: 'Condición expirada',
                            6: 'Premio expirado',
                        };
                        return stateMap[obj.State] || null;
                    },
                },
                {
                    id: 'GlobalState',
                    header: _('Estado global'),
                    width: 150,
                    sort: 'text',
                    /**
                     * Template function to display global state based on its value.
                     * @param {Object} obj - The data object for the row.
                     * @returns {String|null} The global state as a string or null.
                     */
                    template: function (obj) {
                        const stateMap = {
                            1: 'Pendiente',
                            2: 'Cumplido',
                            3: 'Redimido',
                            4: 'Fallido',
                            5: 'Condición expirada',
                            6: 'Premio expirado',
                        };
                        return stateMap[obj.GlobalState] || null;
                    },
                },
                {
                    id: 'CreationDate',
                    header: _('Fecha Creación'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 250,
                    sort: 'text',
                    format: dateFormat, // Date formatting for the creation date
                },
                {
                    id: 'CondExpirationDate',
                    header: _('Fecha expiración condición'),
                    width: 250,
                    sort: 'text',
                    /**
                     * Template function to display condition expiration date.
                     * @param {Object} obj - The data object for the row.
                     * @returns {String} The formatted expiration date or 'No definida'.
                     */
                    template: function (obj) {
                        if (obj.CondExpirationDate == '-1' || obj.CondExpirationDate == -1) {
                            return 'No definida'; // No expiration defined
                        } else {
                            return dateFormat(obj.CondExpirationDate); // Format the date
                        }
                    },
                },
                {
                    id: 'AwardExpirationDate',
                    header: _('Fecha expiración Premio'),
                    width: 250,
                    sort: 'text',
                    /**
                     * Template function to display award expiration date.
                     * @param {Object} obj - The data object for the row.
                     * @returns {String} The formatted expiration date or 'No definida'.
                     */
                    template: function (obj) {
                        if (obj.AwardExpirationDate == '-1' || obj.AwardExpirationDate == -1) {
                            return 'No definida'; // No expiration defined
                        } else {
                            return dateFormat(obj.AwardExpirationDate); // Format the date
                        }
                    },
                },
                {
                    id: 'RedemptionDate',
                    header: _('Fecha de modificación'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 250,
                    sort: 'text',
                    format: dateFormat, // Date formatting for the redemption date
                },
                {
                    id: 'FulfillmentDate',
                    header: _('Fecha de cumplimiento'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 250,
                    sort: 'text',
                    format: dateFormat, // Date formatting for the fulfillment date
                },
            ],
            on: {
                // Event handlers for the DataTable
                /**
                 * Event handler for before loading data.
                 */
                onBeforeLoad: function () {
                    this.showOverlay(
                        "<div id='contenedor' class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    ); // Show loading overlay
                },
                /**
                 * Event handler for after loading data.
                 */
                onAfterLoad: function () {
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            /**
             * Event handler for when the DataTable is ready.
             */
            ready: function () {
                if (!this.count()) {
                    webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                    this.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // Show no data message
                            '</div>',
                    );
                }
            },
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID for pagination
        };
        return {
            rows: [detailReport], // Return the layout with the detail report
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = devConfig.geturlApi() + 'es/Report/GetReferredConditionsReport'; // API endpoint for fetching report data
        var filter = ''; // Filter string for API requests

        // Event listener for filtering data in the report
        this.on(this.app, 'referralsAwardsReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'RedemptionDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&RedemptionDateFrom=' + date[0];
                        string1 = string1 + '&RedemptionDateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'DatepickerDeposit') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            if (
                                object[i][0] != 'Sort' &&
                                object[i][0] != 'Dir' &&
                                object[i][0] != 'Date' &&
                                object[i][0] != 'Date2'
                            ) {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append filter parameter
                            } else {
                                if (object[i][0] == 'Date') {
                                    var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                    string1 = string1 + '&dateFrom=' + date;
                                    string1 = string1 + '&dateTo=' + date;
                                }
                                if (object[i][0] == 'Date2') {
                                    var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                    string1 = string1 + '&dateFrom2=' + date;
                                    string1 = string1 + '&dateTo2=' + date;
                                }
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object from start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object from end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('datatableDetails').clearAll(); // Clear existing data in the DataTable
            $$('datatableDetails').load(
                url + '?start=0&count=' + $$('datatableDetails').data.$pagesize + string1, // Load new data with filters applied
            );
            filter = string1; // Update filter variable
        });
    }
}

// FILE DOCUMENTED
